export default __webpack_public_path__ + "static/media/card-m-service@2x.49134dba.png";